import React, { useEffect } from 'react';
import { Auth0Service } from 'services/Auth0Service';

const NotFoundComponent: React.FunctionComponent = () => {
  useEffect(() => {
    if (window.location.hash.includes('access_token')) {
      Auth0Service.parseAuth0Callback();
      return;
    }
  }, []);

  return (
    <div className="container emptySpacer my-5">
      <h4>Page Not Found</h4>
    </div>
  );
};

export default NotFoundComponent;
